import storage from 'redux-persist/lib/storage';

export const themePersistConfig = {
  key: 'theme',
  storage,
};
